import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=48255fc0&scoped=true"
import script from "./Money.vue?vue&type=script&lang=ts"
export * from "./Money.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48255fc0",
  null
  
)

export default component.exports